<template>
        <v-card class="elevation-10">
            <v-card-title>
                Agents
                <v-spacer></v-spacer>
                <v-text-field
                        v-model="search"
                        append-icon="search"
                        label="Search"
                        single-line
                        hide-details
                ></v-text-field>
            </v-card-title>
            <v-data-table
                    :headers="headers"
                    :items="agents.data"
                    :search="search"
                    :pagination.sync="pagination"
                    hide-actions
                    :loading="loading"
                    :total-items="8"
            >
                <template slot="items" slot-scope="props">
                    <td>{{ props.item.name }}</td>
                    <td class="text-xs" ><v-btn :to="{ name: 'admin.agents.detail', params : { id : props.item.id } }" flat small>{{ props.item.email }}</v-btn></td>
                    <td class="layout px-0 align-center">
                        <v-menu
                                transition="slide-y-transition"
                                bottom
                                left
                        >
                            <v-btn
                                    slot="activator"
                                    color="primary"
                                    dark
                                    fab
                                    flat
                            >
                                <v-icon>settings</v-icon>
                            </v-btn>
                            <v-list>
                                <v-list-tile>
                                    <v-btn flat block v-on:click="deleteItem(props.item.id)"><v-icon left>mdi-delete-circle</v-icon>Delete</v-btn>
                                </v-list-tile>
                                <v-list-tile>
                                    <v-btn flat block><v-icon left>email</v-icon>Send email</v-btn>
                                </v-list-tile>
                            </v-list>
                        </v-menu>
                    </td>
                </template>
                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                    Your search for "{{ search }}" found no results.
                </v-alert>
            </v-data-table>
            <div class="text-xs-center pt-4 pb-4" v-if="agents.data">
                <v-pagination
                        v-model="page"
                        :length="agents.meta.last_page"
                        color="secondary"
                        circle
                        :total-visible="7"
                        @input="setPage"
                ></v-pagination>
                <p class="subtitle">Showing {{ agents.meta.from }} to {{ agents.meta.to }} of {{ agents.meta.total }} entries</p>
            </div>
        </v-card>
</template>

<script>
    export default {
        data () {
            return {
                search: '',
                page: null,
                last_page: null,
                pagination: {},
                loading: true,
                headers: [
                    {
                        text: 'Name',
                        align: 'left',
                        sortable: false,
                        value: 'name'
                    },
                    { text: 'Email', value: 'email', sortable: false },
                    { text: 'Actions', value: 'action', sortable: false }
                ],
                agents: [],
                direction: 'left',
                fab: [],
                fling: false,
                hover: false,
                tabs: null,
                top: false,
                right: true,
                bottom: true,
                left: false,
                transition: 'slide-x-transition'
            }
        },
        created: function() {
            this.setSectionTitle();
            this.getAgents();
            this.debouncedGetAgents = _.debounce(this.getAgents, 500)
        },
        watch: {
            search: function () {
                this.loading = true;
                this.debouncedGetAgents();
            },
            last_page: function () {
                if (this.page > this.agents.meta.last_page) {
                    this.page = 1;
                }
            }
        },
        methods : {
            setSectionTitle () {
                this.$store.dispatch('setSectionTitle', {
                    title: 'Agents list.'
                });
            },
            deleteItem (id) {
                this.$confirm('Do you really want to delete?').then(res => {
                    if (res == true) {
                        this.$store.dispatch('deleteAgent', {
                            id: id
                        }).then((res) => {

                            this.getAgents();

                        }).catch((error) => {

                        });
                    }
                })
            },
            setPage (page) {
                this.page = page;
                this.getClients();
            },
            getAgents () {
                var params = {
                    filters : {
                        search: this.search,
                        page: this.page
                    }
                };
                this.$store.dispatch('getAgents', params).then((res) => {

                    this.agents = res.data;
                    this.page = res.data.meta.current_page;
                    this.last_page = res.data.meta.last_page;
                    this.loading = false;

                    this.fab = [];

                    for (var i = 0; i < res.data.data.length; i++) {
                        this.fab.push(false);
                    }

                }).catch((error) => {

                });
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/admin/agents/ListComponent.vue